import { Button, Headline, Spacing, Text } from '@vkontakte/vkui';
import VigboTooltipImg from 'img/multiTariff/vigboTooltip.png';
import React, { type RefObject, forwardRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { isRebrandingQuotaLanding } from 'reactApp/appHelpers/featuresHelpers';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipAppearance, ETooltipPlacement, ETooltipSize } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';
import opener from 'reactApp/utils/opener';

import styles from './VigboTooltip.css';

export const VIGBO_TOOLTIP_ID = 'VigboTooltipID';

export const VigboTooltip = forwardRef<HTMLElement>((_, ref) => {
    const email = useSelector(UserSelectors.getEmail);

    const handleOnShow = useCallback(() => {
        // TODO: радар
    }, []);

    const handleClose = useCallback(() => {
        // TODO: радар
        window.localStorage.setItem(`${email}|${VIGBO_TOOLTIP_ID}`, 'true');
    }, []);

    const onButtonClick = useCallback(() => {
        opener('/promo/mailvigbo/');
    }, []);

    return (
        <FloatingTooltip
            target={ref as RefObject<HTMLDivElement>}
            placement={ETooltipPlacement.topStart}
            appearance={ETooltipAppearance.dark}
            size={ETooltipSize.fit}
            allowFlip={false}
            onShow={handleOnShow}
            onClose={handleClose}
            qaId="vigbo-welcome-tooltip"
            usePortal
            belowSticky
            isRebrandingQuotaLanding={isRebrandingQuotaLanding}
            contentClassName={styles.content}
            leftOffset={-23}
            closeOnOutsideClick={false}
        >
            <div className={styles.contentWrapper}>
                <Headline weight="2" className={styles.title}>
                    Одна подписка на два сервиса
                </Headline>
                <Spacing size={4} />
                <Text className={styles.text}>Много места для фото со съёмок и&nbsp;инструменты&nbsp;для&nbsp;фотографа</Text>
                <Spacing size={10} />
                <Button className={styles.button} size="m" mode="secondary" onClick={onButtonClick}>
                    Подробнее
                </Button>
                <img className={styles.image} src={VigboTooltipImg} alt="Вигбо" />
            </div>
        </FloatingTooltip>
    );
});

VigboTooltip.displayName = 'VigboTooltip';
